import { useEffect, useRef } from 'react';
import { GAME } from '../config.js';

/**
 * One requestAnimationFrame loop; passes real frame delta in ms (capped).
 * @param {(deltaMs: number) => void} onFrame
 * @param {boolean} active
 */
export function useGameLoop(onFrame, active) {
    const onFrameRef = useRef(onFrame);

    useEffect(() => {
        onFrameRef.current = onFrame;
    }, [onFrame]);

    useEffect(() => {
        if (!active) return undefined;

        let frameId = null;
        let last = performance.now();

        function loop(now) {
            const deltaMs = Math.min(GAME.MAX_FRAME_MS, Math.max(0, now - last));
            last = now;

            if (deltaMs > 0) {
                onFrameRef.current(deltaMs);
            }

            frameId = requestAnimationFrame(loop);
        }

        frameId = requestAnimationFrame(loop);

        return () => {
            if (frameId) cancelAnimationFrame(frameId);
        };
    }, [active]);
}
